<script>
export default {
  name: 'BaseModule',
  inheritAttrs: false,
  components: {

  },
  props: {
    path: {
      type: String,
      required: true
    },
    setComponentRef: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      $$store: undefined,
      isActive: false,
      isTarget: false
    }
  },
  computed: {
    $editMode () {
      return this.$root.$store.state.editMode
    },
    $localeMode () {
      return this.$root.$store.getters.localeMode
    },
    $store: {
      get () {
        return this.$$store.getters.modulesByPath[this.path]
      },
      set (store) {
        this.$$store = store
      }
    },
    children () {
      return this.$store.getters.children
    }
  },
  beforeDestroy () {
    // TODO: When deleted, the store doesn't exist anymore and throws an error here
    // if (this.$store) {
    //   TODO: to make this work, we have to make the slides in the menu standalone components; reusing them with the actual slides is interfering here
    //   delete this.$store.$componentRef
    // }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler (newPath) {
        this.isTarget = newPath === this.$store.getters.path
        this.isActive = newPath.startsWith(this.$store.getters.path)
      }
    },
    $store: {
      immediate: true,
      deep: false,
      handler (store) {
        if (store && this.setComponentRef) { // might be undefined when deleting
          Object.defineProperty(store, '$componentRef', {
            configurable: true,
            get: () => this
          })
        }
      }
    }
  }
}
</script>
